import React, { useEffect, useState } from "react";
import {
  TextField,
  Stack,
  Autocomplete,
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Checkbox,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { createNewOpeningActionFn } from "../Redux/QuestionPacakge/action";

import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { useNavigate, useParams } from "react-router-dom";
import { DeleteOutline, EditOutlined } from "@mui/icons-material";
import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
import DragHandleIcon from "@mui/icons-material/DragHandle";

// Assuming these are imported from your project files
import DeleteAlert from "../Components/AlertBox/DeleteAlert";
import EditSelectedQuestionModal from "../Components/Modals/EditSelectedQuestionModal";
import ApiAlert from "../Components/AlertBox/ApiAlert";
import { columns } from "../constants/selectedQuestionTab";
import { roleModulePermissions } from "../utils/roleInstance";

// Redux and other imports
import { useDispatch, useSelector } from "react-redux";
import { getRecruitmentCompanyActionFn } from "../Redux/RecruitmentCompany/action";
import { getJobRoleData } from "../Redux/JobRole/action";
import {
  deleteOpeningQuestionActionFn,
  editOpeningQuestionActionFn,
  editQuestionByOpeningActionFn,
  getOpeningByFilterActionFn,
  fetchAiGeneratedQuestions,
} from "../Redux/QuestionPacakge/action";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import AutorenewIcon from "@mui/icons-material/Autorenew";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;

const useStyles = makeStyles((theme) => ({
  editIconButton: {
    "&:hover": { color: "rgb(254, 154, 37)", cursor: "pointer" },
  },
  deleteIconButton: {
    "&:hover": { color: "red", cursor: "pointer" },
  },
  // Style for the sticky action column header and cells
}));

const SelectedQuestion = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [jobRole, setJobRole] = useState("");
  const [data, setData] = useState([]);
  const [openingId, setOpeningId] = useState(null);
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [dataToEdit, setDataToEdit] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [alert, setAlert] = useState(false);
  const [alertStatus, setAlertStatus] = useState(true);
  const [alertContent, setAlertContent] = useState("");
  const [jobRoleDefaultValue, setJobRoleDefaultValue] = useState(null);
  const [rCompanyDefaultValue, setRCompanyDefaultValue] = useState([]);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [sampleQuestions, setSampleQuestions] = useState([]);
  const [checkedRows, setCheckedRows] = useState([]);
  const validData = data.filter(
  (row) => row && row.qId
);

  const handleCheckboxChange = (index) => {
    const updated = [...checkedRows];
    updated[index] = !updated[index];
    setCheckedRows(updated);
  };
  const handleOpenDialog = () => {
    createAiGeneratedQuestions(); // Wait for full process
    setOpenDialog(true);
  };

  const createAiGeneratedQuestions = () => {
    dispatch(fetchAiGeneratedQuestions(jobRoleDefaultValue)).then((res) => {
      if (res.type === `FETCH_AI_GENERATED_QUESTIONS_SUCCESS`) {
        const responseData = res?.payload?.data?.data;
        let extractedQuestions = [];

        // ✅ Handle both array and object structures
        if (Array.isArray(responseData)) {
          const found = responseData.find((item) =>
            Array.isArray(item?.QuestionList),
          );
          extractedQuestions = found?.QuestionList || [];
        } else if (Array.isArray(responseData?.QuestionList)) {
          extractedQuestions = responseData.QuestionList;
        }

        // ✅ Remove any empty or invalid objects
        extractedQuestions = extractedQuestions.filter(
          (q) => q && Object.keys(q).length > 0,
        );
        if (extractedQuestions.length > 0) {
          setSampleQuestions(extractedQuestions);
        } else {
          console.warn("⚠️ No valid QuestionList found in API response:", res);
          setSampleQuestions([]);
          setAlert(true);
          setAlertStatus(false);
          setAlertContent("No AI-generated questions found for this role.");
        }
      } else {
        console.error("❌ Error fetching AI-generated questions:", res);
        setSampleQuestions([]);
        setAlert(true);
        setAlertStatus(false);
        setAlertContent("Failed to fetch AI generated questions.");
      }
    });
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSampleQuestions([]);
  };
  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));

  const jobRoleData = useSelector((state) => state.jobRoleReducer.jobRoles);
  const recruitmentData = useSelector((state) => state.recruitmentReducer.data);
  const { jobRoleId, recCompanyIds } = useParams();

  const [questionAddAction, setQuestionAddAction] = useState(false);
  const [questionEditAction, setQuestionEditAction] = useState(false);
  const [questionDeleteAction, setQuestionDeleteAction] = useState(false);

  // --- All your logic functions remain unchanged ---
  const checkQuestionAddAction = async () => {
    const roleData = { roleModule: "Selected Questions" };
    let rolePermission = await roleModulePermissions.checkUserRoles(
      roleData,
      "add",
    );
    setQuestionAddAction(rolePermission);
  };
  const checkQuestionEditAction = async () => {
    const roleData = { roleModule: "Selected Questions" };
    let rolePermission = await roleModulePermissions.checkUserRoles(
      roleData,
      "edit",
    );
    setQuestionEditAction(rolePermission);
  };
  const checkQuestionDeleteAction = async () => {
    const roleData = { roleModule: "Selected Questions" };
    let rolePermission = await roleModulePermissions.checkUserRoles(
      roleData,
      "delete",
    );
    setQuestionDeleteAction(rolePermission);
  };
  const recruitmentCompanySelect = selected.join();
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleClickOpen = (qId) => {
    setOpen(true);
    setIdToDelete(qId);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleChangeRecCompany = (event, value) => {
    setRCompanyDefaultValue(value);
    setSelected(value.map((val) => val.CompanyId));
  };
  const handleSelectQuestionsOnClick = () => {
    const selectedData = { jobRoleId: jobRole, rCompaniesId: selected };
    window.localStorage.setItem(
      "selectedPageData",
      JSON.stringify(selectedData),
    );
    navigate(
      `/selected_question/select_question/${openingId}/${jobRole}/${recruitmentCompanySelect}`,
    );
  };
  const onDragEnd = (result) => {
    if (!result.destination) return;

    // Current page offset
    const startIndex = page * rowsPerPage;

    // Actual indexes in full data array
    const sourceIndex = startIndex + result.source.index;
    const destinationIndex = startIndex + result.destination.index;

    // Clone full data
    const items = Array.from(data);

    // Remove dragged item
    const [reorderedItem] = items.splice(sourceIndex, 1);

    // Insert into new position
    items.splice(destinationIndex, 0, reorderedItem);

    // Update sort order globally
    const updatedData = items
  .filter(Boolean)
  .map((item, index) => ({
    ...item,
    sort: index + 1,
  }));

    // Update UI
    setData(updatedData);

    // API update
    editSelectedQuestions({
      selectedQuestionList: updatedData,
    });
  };
  const editSelectedQuestionByID = (data) => {
    dispatch(editOpeningQuestionActionFn({ openingId, data })).then((res) => {
      if (res.type === "EDIT_OPENING_QUESTION_SUCCESS") {
        getSelectedQuestion();
        setEditOpen(false);
        setAlert(true);
        setAlertStatus(true);
        setAlertContent("Question Updated Successfully");
      } else {
        getSelectedQuestion();
        setEditOpen(false);
        setAlert(true);
        setAlertStatus(false);
        setAlertContent("Internal server error please try again!");
      }
    });
  };
  const editSelectedQuestions = (data) => {
    dispatch(editQuestionByOpeningActionFn({ openingId, data })).then((res) => {
      if (res.type === "EDIT_OPENING_QUESTION_SUCCESS") {
        getSelectedQuestion();
      } else {
        console.error("Failed to sync question order");
      }
    });
  };
  const AlerthandleClose = () => {
    setAlert(false);
  };
  const packageQuestionDelete = () => {
    dispatch(deleteOpeningQuestionActionFn({ openingId, idToDelete })).then(
      (res) => {
        if (res.type === `DELETE_OPENING_QUESTION_SUCCESS`) {
          handleClose();
          getSelectedQuestion();
        } else {
          console.log("err: ", res);
        }
      },
    );
  };
  const getSelectedQuestion = async () => {
    if (jobRole && selected.join()) {
      dispatch(
        getOpeningByFilterActionFn(jobRole, recruitmentCompanySelect),
      ).then((res) => {
        if (res.type === "GET_OPENING_BY_FILTER_SUCCESS") {
          let questionDetails = res.payload.selectedQuestionList;
          questionDetails.sort((a, b) => a.sort - b.sort);
          setData(questionDetails);
          setOpeningId(res.payload.openingId);
        } else {
          setData([]);
          setOpeningId(null);
        }
      });
    }
  };
  useEffect(() => {
    getSelectedQuestion();
    if (!selected?.length || !jobRole) {
      setData([]);
      setOpeningId(null);
    }
  }, [jobRole, selected]);
  useEffect(() => {
    if (jobRoleId && jobRoleData?.data && !jobRoleDefaultValue) {
      let filteredJobRole = jobRoleData.data.find(
        (job) => job.jobId === jobRoleId,
      );
      if (filteredJobRole) {
        setJobRoleDefaultValue(filteredJobRole);
        setJobRole(filteredJobRole.jobId);
      }
    }
    if (
      recCompanyIds &&
      recruitmentData.length > 0 &&
      rCompanyDefaultValue.length === 0
    ) {
      let filteredRecCompanies = recruitmentData.filter((recC) =>
        recCompanyIds.split(",").includes(recC.CompanyId),
      );
      setRCompanyDefaultValue(filteredRecCompanies);
      setSelected(filteredRecCompanies.map((c) => c.CompanyId));
    }
    checkQuestionAddAction();
    checkQuestionEditAction();
    checkQuestionDeleteAction();
  }, [jobRoleData, recruitmentData, jobRoleId, recCompanyIds]);
  useEffect(() => {
    dispatch(getRecruitmentCompanyActionFn(1, 5000, "", true));
    dispatch(getJobRoleData(1, 5000, "", true));
  }, [dispatch]);
  const handleOnClickEditSelectedQuestion = (row) => {
    const preparedData = {
      ...row,
      documentCategory:
        typeof row.documentCategory === "string" ? row.documentCategory : "",
    };
    setEditOpen(true);
    setDataToEdit(preparedData);
  };

  const handleDefaultSelectQuestionsOnClick = async (selectedQuestions) => {
    let datas = selectedQuestions.map((q) => {
      return { ...q, id: q.qId };
    });

    dispatch(
      createNewOpeningActionFn(openingId, {
        jobRoleId: jobRole,
        companyIds: Array.isArray(recruitmentCompanySelect)
          ? recruitmentCompanySelect
          : [recruitmentCompanySelect],
        selectedQuestionList: datas,
        // peopleToBeNotified: notify
      }),
    ).then((res) => {
      if (res.type === `CREATE_NEW_OPENING_SUCCESS`) {
        setData(datas);
      } else {
        setAlert(true);
        setAlertStatus(false);
      }
    });
  };

  const handleAddClick = () => {
    const selectedQuestions = sampleQuestions.filter((_, i) => checkedRows[i]);
    handleCloseDialog();
    handleDefaultSelectQuestionsOnClick(selectedQuestions);
    setCheckedRows(sampleQuestions?.map(() => true) || []);
  };

  useEffect(() => {
    if (sampleQuestions && sampleQuestions.length > 0) {
      setCheckedRows(sampleQuestions.map(() => true)); // all checked by default
    }
  }, [sampleQuestions]);
  return (
    <>
      <BootstrapDialog
        onClose={handleCloseDialog}
        aria-labelledby="customized-dialog-title"
        open={openDialog}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          id="customized-dialog-title"
        >
          <Box>AI Generated Questions </Box>
          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
              fontSize: "13px",
              cursor: "pointer",
            }}
            onClick={createAiGeneratedQuestions}
          >
            <Tooltip title="Try again">
              <AutorenewIcon sx={{ fontSize: "20px" }} />
            </Tooltip>
          </Box> */}
        </DialogTitle>

        <DialogContent dividers>
          <Box
            sx={{
              height: { xs: "60vh", sm: "70vh", md: "75vh" },
              overflow: "auto",
            }}
          >
            <TableContainer
              component={Paper}
              sx={{
                borderRadius: 2,
                boxShadow: 2,
                maxHeight: "100%",
              }}
            >
              <Table stickyHeader aria-label="questions table">
                <TableHead>
                  <TableRow sx={{ backgroundColor: "primary.main" }}>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: "white",
                      }}
                    >
                      Select
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: "white",
                      }}
                    >
                      SL
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: "white",
                      }}
                    >
                      Question
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: "white",
                      }}
                    >
                      Question Type
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: "white",
                      }}
                    >
                      Weightage
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: "white",
                      }}
                    >
                      Mandatory
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: "white",
                      }}
                    >
                      Expected Document
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {sampleQuestions?.map((row, idx) => (
                    <TableRow
                      key={idx}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
                      }}
                    >
                      <TableCell>
                        <Checkbox
                          checked={checkedRows[idx] || false}
                          onChange={() => handleCheckboxChange(idx)}
                          color="primary"
                        />
                      </TableCell>
                      <TableCell>{idx + 1}</TableCell>
                      <TableCell>{row.Question}</TableCell>
                      <TableCell>{row.questionType}</TableCell>
                      <TableCell>{row.Weight}</TableCell>
                      <TableCell>{row.mandatoryQuestion}</TableCell>
                      <TableCell>{row.expectDocument}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "space-between", px: 3 }}>
          <Button onClick={handleCloseDialog} variant="outlined" color="error">
            Cancel
          </Button>
          <Button onClick={handleAddClick} variant="contained" color="primary">
            Add
          </Button>
        </DialogActions>
      </BootstrapDialog>

      {alert && (
        <ApiAlert
          open={alert}
          snackbaronClose={AlerthandleClose}
          alertonClose={AlerthandleClose}
          alertType={alertStatus ? "success" : "error"}
          Content={alertContent}
        />
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 90px)",
          width: "100%",
          p: { xs: 1, sm: 2 },
          gap: 2,
        }}
      >
        {/* --- FILTERS --- */}
        <Stack
          direction={{ xs: "column", md: "row" }}
          gap={2}
          sx={{ width: "97%" }}
        >
          <Autocomplete
            fullWidth
            freeSolo
            id="job-role-data"
            options={jobRoleData?.data?.filter((r) => r.jobRoleStatus) || []}
            value={jobRoleDefaultValue}
            isOptionEqualToValue={(option, value) =>
              option.jobId === value.jobId
            }
            getOptionLabel={(option) =>
              `${option.role} (${(option.cities || []).join(", ")})`
            }
            onChange={(e, val) => {
              setJobRoleDefaultValue(val);
              setJobRole(val?.jobId || "");
            }}
            renderOption={(props, option) => (
              <li {...props} key={option.jobId}>
                {option.role} ({(option.cities || []).join(", ")})
              </li>
            )}
            renderInput={(params) => <TextField {...params} label="Job Role" />}
          />
          <Autocomplete
            multiple
            fullWidth
            id="recruitment-company-data"
            options={recruitmentData?.filter((c) => c.companyStatus) || []}
            disableCloseOnSelect
            getOptionLabel={(option) => option.name}
            value={rCompanyDefaultValue}
            onChange={handleChangeRecCompany}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={<CheckBoxIcon />}
                  checked={selected}
                />
                {option.name}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} label="Recruitment Company" />
            )}
          />
          <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
            {data.length === 0 && (
              <Button
                variant="contained"
                sx={{
                  height: 56,
                  width: { xs: "48%", md: 150 },
                  flexShrink: 0,
                  borderRadius: "10px",
                  fontSize: "12px",
                }}
                disabled={
                  !jobRole || !recruitmentCompanySelect || !questionAddAction
                }
                onClick={handleOpenDialog}
              >
                AI Generated Questions
              </Button>
            )}
            <Button
              variant="contained"
              sx={{
                height: 56,
                width: { xs: data.length === 0 ? "48%" : "100%", md: 150 },
                flexShrink: 0,
                borderRadius: "10px",
                fontSize: "12px",
              }}
              disabled={
                !jobRole || !recruitmentCompanySelect || !questionAddAction
              }
              onClick={handleSelectQuestionsOnClick}
            >
              Select Questions
            </Button>
          </Box>
        </Stack>

        {/* --- CONTENT AREA (TABLE) --- */}
        <Paper
          sx={{
            width: "100%",
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <TableContainer sx={{ flexGrow: 1, overflow: "auto" }}>
            <Table stickyHeader sx={{ minWidth: 1200 }}>
              {/* Set a minWidth for the table */}
              <TableHead>
                <TableRow>
                  {columns.map((col) => (
                    <TableCell
                      key={col.id}
                      align={col.align}
                      className={
                        col.id === "Action" ? classes.stickyHeader : ""
                      }
                      sx={{
                        minWidth: col.minWidth,
                        backgroundColor: "primary.main",
                        color: "white",
                      }}
                    >
                      {col.id === "Action" &&
                      !(questionEditAction || questionDeleteAction)
                        ? ""
                        : col.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable-questions-table">
                  {(provided) => (
                    <TableBody
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      sx={{ cursor: "pointer" }}
                    >
                      {validData
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                        .map((row, index) => {
                          // Calculate the real index in the data array
                          const realIndex = page * rowsPerPage + index; 
                          return(
                          <Draggable
                            key={row.qId}
                            draggableId={String(row.qId)}
                            index={index}
                            >
                            {(provided) => (
                              <TableRow
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                hover
                              >
                                {/* Cells are now mapped for better maintainability */}
                                <TableCell
                                  {...provided.dragHandleProps}
                                  sx={{ padding: { xs: 1, sm: 2 } }}
                                >
                                  <DragHandleIcon
                                    sx={{
                                      cursor: "grab",
                                      color: "text.secondary",
                                    }}
                                  />
                                </TableCell>
                                <TableCell
                                  align="right"
                                  sx={{ padding: { xs: 1, sm: 2 } }}
                                >
                                  {page * rowsPerPage + index + 1}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  sx={{
                                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                    padding: { xs: 1, sm: 2 },
                                  }}
                                >
                                  {row.Question || "N/A"}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{
                                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                    padding: { xs: 1, sm: 2 },
                                  }}
                                >
                                  {row.questionType || "N/A"}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{ padding: { xs: 1, sm: 2 } }}
                                >
                                  {row.Weight || "N/A"}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{ padding: { xs: 1, sm: 2 } }}
                                >
                                  {row.Ack || "N/A"}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{ padding: { xs: 1, sm: 2 } }}
                                >
                                  {row.mandatoryQuestion || "N/A"}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{ padding: { xs: 1, sm: 2 } }}
                                >
                                  {row.defaultValue || "N/A"}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{ padding: { xs: 1, sm: 2 } }}
                                >
                                  {row.expectDocument === "yes" ? "Yes" : "No"}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{ padding: { xs: 1, sm: 2 } }}
                                >
                                  {row["Next Question Prefix"] || "N/A"}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  className={classes.stickyActionColumn}
                                >
                                  <Stack
                                    direction="row"
                                    spacing={1}
                                    justifyContent="center"
                                  >
                                    {questionEditAction && (
                                      <Tooltip title="Edit">
                                        <EditOutlined
                                          className={classes.editIconButton}
                                          onClick={() =>
                                            handleOnClickEditSelectedQuestion(
                                              row,
                                            )
                                          }
                                        />
                                      </Tooltip>
                                    )}
                                    {questionDeleteAction && (
                                      <Tooltip title="Delete">
                                        <DeleteOutline
                                          className={classes.deleteIconButton}
                                          onClick={() =>
                                            handleClickOpen(row.qId)
                                          }
                                        />
                                      </Tooltip>
                                    )}
                                  </Stack>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                          );
                        })}
                      {provided.placeholder}
                    </TableBody>
                  )}
                </Droppable>
              </DragDropContext>
            </Table>
          </TableContainer>

          {/* --- PAGINATION --- */}
          <TablePagination
            component="div"
            count={validData.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{ flexShrink: 0, borderTop: 1, borderColor: "divider" }}
          />
        </Paper>
      </Box>

      {/* --- MODALS --- */}
      <DeleteAlert
        open={open}
        onClose={handleClose}
        handleDelete={packageQuestionDelete}
        header="Delete Question"
        message="Are you sure you want to delete this question?"
        rightButton="Delete"
      />
      {dataToEdit && (
        <EditSelectedQuestionModal
          open={editOpen}
          setOpen={setEditOpen}
          data={dataToEdit}
          editSelectedQuestion={editSelectedQuestionByID}
          allSelectedQuestions={data}
          jobRoleDefaultValue={jobRoleDefaultValue}
        />
      )}
    </>
  );
};

export default SelectedQuestion;
